<template>
  <div>
    <el-button type="primary" size="mini" @click="handleSelectionChange(1)"
      >加密锁</el-button
    >
    <el-dialog
      title="加密锁详情"
      :visible.sync="dialogTableVisible"
      v-if="dialogTableVisible"
    >
      <el-form :model="ruleForm">
        <el-form-item>
          {{ "加密锁号" }}
          <el-input v-model="ruleForm.jiamisuo" clearable></el-input>
        </el-form-item>
        <el-form-item>
          {{ "内部锁号" }}
          <el-input v-model="ruleForm.suohao" clearable></el-input>
        </el-form-item>
        <el-form-item
          v-for="(modelform, index) in ruleForm.module"
          :key="index"
        >
          {{ modelform.name }}
          <el-input :readonly="true" v-model="ruleForm.mokuai[index]">
            <el-button slot="append">
              <app-Modular
                @ievent="ievent"
                :ruleForm="modelform"
                :index="Number(index)"
              ></app-Modular>
            </el-button>
          </el-input>
        </el-form-item>
        <el-button type="primary" @click="submitCodemeter">确认上传</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    htid: Number,
  },
  data() {
    return {
      innerVisible: false,
      dialogTableVisible: false,
      tableData: [],
      vule: 0,
      ruleForm: {
        value1: true,
        jiamisuo: "",
        suohao: "",
        mokuai: {},
        module: {},
        contractId: "",
      },
      xuanzhongshuju: [],
    };
  },
  methods: {
    handleSelectionChange(x) {
      this.ruleForm.jiamisuo = "";
      this.ruleForm.suohao = "";
      this.ruleForm.mokuai = {};
      if (this.vule == 0) {
        this.vule == x;
      } else {
        this.dialogTableVisible = true;
        return;
      }
      this.$http
        .post(this.$getaxiosurl("/enc/product/getAllPMInfo"))
        .then((response) => {
          if (response.data.code == "00100") {
            for (var i = 0; i < response.data.data.length; i++) {
              this.$set(this.ruleForm.module, i, response.data.data[i]);
            }
            this.dialogTableVisible = true;
          } else {
            this.tableData = null;
            this.$message({
              message: "没有相关合同信息",
              type: "error",
            });
          }
        });
    },
    ievent(data, index) {
      let asdasd = "";
      if (this.xuanzhongshuju.length == 0) {
        data.forEach((e) => {
          this.xuanzhongshuju.push(e);
        });
      } else {
        for (let l = 0; l < this.xuanzhongshuju.length; l++) {
          if (this.xuanzhongshuju[l].pid == this.ruleForm.module[index].id) {
            this.xuanzhongshuju.splice(l, 1, "");
          }
        }
        data.forEach((e) => {
          this.xuanzhongshuju.push(e);
        });
      }

      for (let i = 0; i < data.length; i++) {
        asdasd =
          asdasd + data[i].moduleName + "—" + data[i].node + "节点" + ",";
      }
      this.$set(this.ruleForm.mokuai, index, asdasd);
    },
    submitCodemeter() {
      if (
        this.ruleForm.jiamisuo.length <= 0 ||
        this.ruleForm.suohao.length <= 0
      ) {
        return this.$message({
          showClose: true,
          message: "加密锁号,内部锁号不能为空",
          type: "error",
        });
      }

      let modulist = [];
      for (let i = 0; i < this.xuanzhongshuju.length; i++) {
        if (this.xuanzhongshuju[i] != "") {
          modulist.push(this.xuanzhongshuju[i]);
        }
      }
      let Params = {
        encryptNo: this.ruleForm.jiamisuo,
        innerEncryptNo: this.ruleForm.suohao.trim(),
        contractId: this.htid,
        modules: modulist,
      };
      this.$http
        .post(
          this.$getaxiosurl("/enc/contract/createLock"),
          JSON.stringify(Params)
        )
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: "数据录入成功",
              type: "success",
            });
            this.dialogTableVisible = false;
            this.xuanzhongshuju = [];
          } else {
            if (response.data.code != "00100") {
              this.$message({
                showClose: true,
                message: response.data.msg,
                type: "error",
              });
            }
          }
        });
    },
  },
};
</script>
<style scoped>
</style>